import {toast} from "react-toastify"

import {EFeature, isFeatureEnabled} from "./featureFlags.ts"

export enum EGTMEvent {
  COMPANY_SIGNUP_START = "1_join_company",
  COMPANY_SIGNUP_SEND = "1_join_closerocket",
  COMPANY_SIGNUP_VERIFY = "1_verification",
  COMPANY_COUNTRY_SELECTED = "1_country",
  COMPANY_SALES_PERSON_REQUESTED = "1_sales_form",
  COMPANY_CHECKOUT_STARTED = "1_checkout",
  COMPANY_CHECKOUT_SEND = "1_purchase",
  SALES_SIGNUP_START = "2_join_sales",
  SALES_SIGNUP_SEND = "2_join_closerocket",
  SALES_SIGNUP_VERIFY = "2_verification",
  SALES_PROFILE_SEND = "2_sales_profile",

  LEADS_SEARCH = "leads_search",
  LEADS_ADVANCED_SEARCH_TRIGGERED = "leads_advanced_search_triggered",
  LEADS_ADVANCED_SEARCH_SEARCHING = "leads_advanced_search_searching",
  LEADS_ADVANCED_SEARCH_ADDING = "leads_advanced_search_adding",
  LEADS_ADVANCED_SEARCH_COMPLETED = "leads_advanced_search_completed",
}

type TGTMSpecificEvent =
  | {event: EGTMEvent.COMPANY_SIGNUP_START}
  | {event: EGTMEvent.COMPANY_SIGNUP_SEND; email: string}
  | {event: EGTMEvent.COMPANY_SIGNUP_VERIFY; company: string; phone: string}
  | {event: EGTMEvent.COMPANY_COUNTRY_SELECTED}
  | {event: EGTMEvent.COMPANY_SALES_PERSON_REQUESTED}
  | {event: EGTMEvent.COMPANY_CHECKOUT_STARTED}
  | {event: EGTMEvent.COMPANY_CHECKOUT_SEND; phone: string; email: string; value: number}
  | {event: EGTMEvent.SALES_SIGNUP_START}
  | {event: EGTMEvent.SALES_SIGNUP_SEND; email: string}
  | {event: EGTMEvent.SALES_SIGNUP_VERIFY; name: string; phone: string}
  | {event: EGTMEvent.SALES_PROFILE_SEND; name: string; phone: string; email: string}
  | {event: EGTMEvent.LEADS_SEARCH}
  | {event: EGTMEvent.LEADS_ADVANCED_SEARCH_TRIGGERED}
  | {event: EGTMEvent.LEADS_ADVANCED_SEARCH_SEARCHING}
  | {event: EGTMEvent.LEADS_ADVANCED_SEARCH_ADDING; added: number; removed: number; total: number}
  | {
      event: EGTMEvent.LEADS_ADVANCED_SEARCH_COMPLETED
      addedLeads: number
      addedProspects: number
      removed: number
      total: number
    }

type TGTMEvent = {event: EGTMEvent} & Record<string, any>

export function emitGTMEvent(data: TGTMSpecificEvent) {
  if (isFeatureEnabled(EFeature.GTM_EVENT_TOASTS)) {
    const {event, ...params} = data
    toast.info(
      <div className={"flex flex-col"}>
        <h1>
          GTM event fired: <span className={"font-bold"}>{event}</span>
        </h1>
        {Object.keys(params).length > 0 && <pre>{JSON.stringify(params, null, 2)}</pre>}
      </div>
    )
  }
  ;(
    window as typeof window & {
      dataLayer?: {push: (args: TGTMEvent) => void}
    }
  ).dataLayer?.push(data)
}
